<div class="flex questionnaire-container">
  <app-header [showHeader]="true"></app-header>
  <!--stepper-->
  <div *ngIf="showHeader" style="padding: 0.8rem">
    <app-stepper></app-stepper>
  </div>
  <router-outlet></router-outlet>
</div>
